
export const API = {
  WEBSITE_URL: process.env.REACT_APP_WEBSITE_URL || "",
  PRABHAATHAM_URL: process.env.REACT_APP_PRABHAATHAM_URL || "",

  BASE_URL: process.env.REACT_APP_BASE_URL || "",

  CDN_URL: process.env.REACT_APP_CDN_URL || "",
  CDN_PASSTHROUGH_HOST: process.env.REACT_APP_CDN_PASSTHROUGH_HOST || "",
  UPLOAD_URL: process.env.REACT_APP_UPLOAD_URL || "",

  ADSENSE_CLIENT: process.env.REACT_APP_ADSENSE_CLIENT || "",
  ADSENSE_SLOT_STICKY: process.env.REACT_APP_ADSENSE_SLOT_STICKY || "",
  ADSENSE_SLOT_BOX: process.env.REACT_APP_ADSENSE_SLOT_BOX || "",
  ADSENSE_SLOT_INLINE: process.env.REACT_APP_ADSENSE_SLOT_INLINE || "",

  EPAPER: "ePaper",
  EPAPER_ENHANCED: "epaper/enhanced",
  NJAYAR_MASTER: "njayarprabhaadham-masters",
  VIDYA_PRABHAATHAM: "vidyaprabhaadhams",
  SUBSCRIPTION_PLANS: "subscription-plans",
  PAYTABS_CREATE: "paytabs/subscription/create",
  RENEWAL_LINK_INFO: "epaper-users/renewal-link/", // + :token/info
  PAYTABS_RENEWAL_COMPLETE: "epaper-users/me/paytabs-renewal/complete",
  // Public: E-Paper Settings countries (currency, default amount).
  EPAPER_SETTINGS_CONFIG: "epaper-users/epaper-settings/config",
};
